// extracted by mini-css-extract-plugin
module.exports = {"fontPoppins":"Login_fontPoppins__1Yr4N","leftPane":"Login_leftPane__1JHzb","rightPane":"Login_rightPane__efnvo"};